<template>
        <div>
            <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
                <div v-if="this.isMobile">
                    <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
                </div>
                <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
                    {{ this.$store.state.modal.content.title }}
                </div>
                <div v-if="!this.isMobile">
                    <Icon name="close" class="c24 pointer" @click="this.close()"/>
                </div>
            </div>
            <div class="p24 mb-0 content">
                <div class="d-flex flex-column gap16 neue-roman">
                    <div class="mb12">
                        {{ $t('components.service.modal.p2p.ConfirmInternalPay.1') }}
                    </div>
                    <div>{{ $t('components.service.modal.p2p.ConfirmInternalPay.2') }}</div>
                </div>
                <div class="d-flex mt24" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }">
                    <Button type="btn-warning" class="equal-width h48 mr16 status-text-red border-full" @click="this.save()">{{ $t('components.service.modal.p2p.ConfirmInternalPay.3') }}</Button>
                    <Button type="btn-outline-grey" class="equal-width h48 primary-grey" @click="this.clearAll()">{{ $t('components.service.modal.p2p.ConfirmInternalPay.4') }}</Button>
                </div>
            </div>
        </div>
</template>

<script>
import Icon from '@/components/icons/Icon'
import Button from '@/components/service/Button'

export default {
    name: 'ConfirmInternalPay',
    components: {
        Icon,
        Button
    },
    data() {
        return {
            internal_amount: this.$store.state.modal.content.internal_amount,
            internal_curr_text: this.$store.state.modal.content.internal_curr_text,
        }
    },
    props: {
        close: {
            type: Function,
            required: true
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.isMobile
        }
    },
    methods: {
        summMask(sum) {
            if (!sum) {
                return '';
            }
            let arr = sum.split('.');
            if (arr[1]) {
                return `<span class='text-black neue fw-medium fsp32 lh40'>${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span><span class='fsp18 primary-grey lh18'>.${arr[1]}</span>`
            } else {
                return `<span class='text-black neue fw-medium fsp32 lh40'>${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span>`
            }
        },
        save() {
            if (this.$store.state.modal.content.callback) {
                this.$store.state.modal.content.callback();
            }
            this.close();
        },
    }
}
</script>

